import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useStateValue } from "../StateProvider.js";
/* metamask code */
import MetaMaskOnboarding from "@metamask/onboarding";
const ONBOARD_TEXT = "Click to install MetaMask!";
const CONNECT_TEXT = "Connect to MetaMask";
const CONNECTED_TEXT = "Connected to MetaMask";
// const NOT_CONNECTED = "Not connected";
/* metamask code */
// import { Connection, clusterApiUrl, LAMPORTS_PER_SOL } from "@solana/web3.js";

function Navbar() {
  const [{ global }, dispatch] = useStateValue();
  // const getProvider = async () => {
  //     if ("solana" in window) {
  //         // opens wallet to connect to
  //         await window.solana.connect();
  //         const provider = window.solana;
  //         if (provider.isPhantom) {
  //             console.log("Is Phantom installed?", provider.isPhantom);
  //             if(window.solana.isConnected){
  //                 setConnectButtonText('Connected');
  //             }
  //             return provider;
  //         }
  //     } else {
  //         window.open("https://www.phantom.app/", "_blank");
  //     }
  // };
  // const checkWallet = useCallback(() => {
  //     // window.solana.on("connect", () => setConnectButtonText('Connected'));
  //     (async () => {
  //         const isPhantomInstalled = await window.solana && await window.solana.isPhantom;
  //         console.log('wallet',isPhantomInstalled,window.solana);
  //         if(isPhantomInstalled){
  //             setConnectButtonText('Connect Wallet');
  //         }
  //         if(window.solana!==undefined){
  //             if(window.solana.isConnected){
  //                 setConnectButtonText('Connected');
  //             }
  //         }
  //     })();
  // }, [setConnectButtonText])

  // useEffect(() => {
  //     if(window.solana!==undefined){
  //         window.solana.on("connect", () => {
  //             console.log('updated...')
  //         })
  //         window.solana.on('disconnect', () => {
  //             console.log('disconnected...');
  //             setConnectButtonText('Connect Wallet');
  //         })
  //         return () => {
  //             window.solana.disconnect();
  //         }
  //     }
  // }, [])

  // async function getWallet() {
  //     try {
  //     const wallet = typeof window !== 'undefined' && window.solana;
  //         await wallet.connect()
  //     } catch (err) {
  //         console.log('err: ', err)
  //     }
  // }

  // const connectWallet = () => {
  //     (async () => {
  //         try {
  //             const resp = await window.solana.request({ method: "connect" });
  //             resp.publicKey.toString()
  //             // 26qv4GCcx98RihuK3c4T6ozB3J7L6VwCuFVc7Ta2A3Uo
  //         } catch (err) {
  //             // { code: 4001, message: 'User rejected the request.' }
  //         }
  //     })();
  // }
  // const disconnectWallet = () => {
  //     (async () => {
  //         try {
  //             const resp = await window.solana.request({ method: "disconnect" });
  //             resp.publicKey.toString()
  //             // 26qv4GCcx98RihuK3c4T6ozB3J7L6VwCuFVc7Ta2A3Uo
  //         } catch (err) {
  //             // { code: 4001, message: 'User rejected the request.' }
  //         }
  //     })();
  // }
  // useEffect(() => {
  //     checkWallet();
  // }, [checkWallet]);

  /* metamask code */
  const [buttonText, setButtonText] = useState(ONBOARD_TEXT);
  // const [AddressText, setAccountAddress] = useState(NOT_CONNECTED); //set current metamask address value
  const [NetworkText, setAccountNetwork] = useState([]); //set network id if connected
  const [ChainText, setAccountChain] = useState([]); //set chain id if connected
  const [isDisabled, setDisabled] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const onboarding = React.useRef();

  // function renderSwitch(param) {
  //   switch (param) {
  //     case 1:
  //       return "Ethereum Mainnet";
  //     case 42:
  //       return "Kovan";
  //     case 3:
  //       return "Ropsten";
  //     case 4:
  //       return "Rinkeby";
  //     case 5:
  //       return "Goerli";
  //     case 56:
  //       return "Binance Smart Chain";
  //     default:
  //       return "";
  //   }
  // }

  useEffect(() => {
    if (!onboarding.current) {
      onboarding.current = new MetaMaskOnboarding();
    }
  }, []);

  useEffect(() => {
    if (MetaMaskOnboarding.isMetaMaskInstalled()) {
      if (accounts.length > 0) {
        setButtonText(CONNECTED_TEXT);
        setDisabled(true);
        onboarding.current.stopOnboarding();
        // var ethDefaultAccount = accounts[0];
        // setAccountAddress(ethDefaultAccount);
      } else {
        setButtonText(CONNECT_TEXT);
        // setAccountAddress(NOT_CONNECTED);
        setDisabled(false);
      }
    }
  }, [accounts]);

  useEffect(() => {
    function handleNewAccounts(newAccounts) {
      setAccounts(newAccounts);
    }
    if (MetaMaskOnboarding.isMetaMaskInstalled()) {
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then(handleNewAccounts);
      window.ethereum.on("accountsChanged", handleNewAccounts);
      /*return () => {
            window.ethereum.off('accountsChanged', handleNewAccounts);
        };*/
    }
  }, []);

  useEffect(() => {
    //set default chainid and on changing
    function handleChainChanged(_chainId) {
      //set chain id
      setAccountChain(_chainId);
      // console.log(ChainText);
      //set network id by converting to chainid hex to decimal
      const netId = parseInt(_chainId, 16);
      //console.log(netId);
      setAccountNetwork(netId);
      localStorage.setItem("networkId", netId);
      dispatch({
        type: "changeNetworkId",
        newNetworkId: { networkId: netId },
      });
      // console.log("network", NetworkText);
      //console.log(window.ethereum.getBalance(accounts[0]));
    }
    if (MetaMaskOnboarding.isMetaMaskInstalled()) {
      window.ethereum
        .request({ method: "eth_chainId" })
        .then(handleChainChanged);
      window.ethereum.on("chainChanged", handleChainChanged);
      /*return () => {
                window.ethereum.off('chainChanged', handleChainChanged);
            };*/
    }
  }, [ChainText, NetworkText, dispatch]);

  const onClick = () => {
    if (MetaMaskOnboarding.isMetaMaskInstalled()) {
      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((newAccounts) => setAccounts(newAccounts));
    } else {
      onboarding.current.startOnboarding();
    }
  };
  /* //metamask code */

  return (
    <header className="transparent scroll-dark">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="de-flex sm-pt10">
              <div className="de-flex-col">
                <div className="de-flex-col">
                  {/* logo begin  */}
                  <div id="logo">
                    <Link to="/">
                      <img alt="logo" src="images/background/logo1.png" />
                    </Link>
                  </div>
                  {/* logo close  */}
                </div>
                <div className="de-flex-col"></div>
              </div>
              <div className="de-flex-col header-col-mid">
                {/* mainmenu begin  */}
                <ul id="mainmenu">
                  <li>
                    <Link to="/">
                      Home<span></span>
                    </Link>
                  </li>
                </ul>
                {/* mainmenu close  */}
                <div className="menu_side_area">
                  <Link
                    to="#"
                    className="btn-main"
                    disabled={isDisabled}
                    onClick={onClick}
                  >
                    <i className="icon_wallet_alt"></i>
                    <span>{buttonText}</span>
                  </Link>
                  {/* <span id="menu-btn"></span> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
export default Navbar;
